module.exports = __webpack_public_path__ + "operace-nosu_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_7_before.jpg
// module id = 1140
// module chunks = 0